import { IsInAuthor, IsPreviewGenerator } from "../state/ui";

import { requestFilterNamesFromAuthor } from "./MessageHandler";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";

function RequestDataFromAuthor() {
	const isPreviewer = useRecoilValue(IsPreviewGenerator);
	const isInAuthor = useRecoilValue(IsInAuthor);

	useEffect(() => {
		if (isInAuthor) {
			requestFilterNamesFromAuthor(isPreviewer ? "preview" : "QP");
		}
	}, [isInAuthor, isPreviewer]);
	return <></>;
}

export default RequestDataFromAuthor;
